/**
 * @copyright ngrx
 */
import { Action, ActionReducer } from './index';
import {BehaviorSubject, Observable, observeOn, scan, queueScheduler} from "rxjs";

export class MiniState<T> extends BehaviorSubject<T> {
  constructor(
    _initialState: T,
    actionsDispatcher$: Observable<Action>,
    reducer: ActionReducer<T>
  ) {
    super(_initialState);

    const actionInQueue$ = observeOn.call(actionsDispatcher$, queueScheduler);
    const state$ = scan.call(
      actionInQueue$,
      (state: T, action: Action) => {
        if (!action) {
          return state;
        }

        return reducer(state, action);
      },
      _initialState
    );

    state$.subscribe((value: T) => this.next(value));
  }
}
